import { CareCuesInterface, ReminderGroup, ReminderResponse } from './interfaces';

/**
 * Compacts a free text string into a short, spaceless string.
 * @param {string} input - The free text string to compact.
 * @returns {string} - The compacted, spaceless string.
 */
export function compactString(input: string): string {
  let hash = 0;

  for (let i = 0; i < input.length; i++) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0; // Convert to 32-bit integer
  }

  return Math.abs(hash).toString(36);
}

export const mapRemindersToGroups = (reminderGroups: ReminderGroup[]): CareCuesInterface[] => {
  return reminderGroups.map((group) => ({
    id: group.id,
    title: group.name,
    titleHash: compactString(group.name),
    type: group.groupType,
    loading: false,
    items: group.encounterReminders.map(({ displayText, reminder, status, id }) => ({
      id,
      name: reminder.name,
      displayText: displayText ?? reminder.alert,
      displayTextHash: compactString(displayText ?? reminder.alert),
      status,
      loading: false,
    })),
  }));
};

export const extractPendingResponses = (reminderResponses: ReminderResponse[]) => {
  return reminderResponses
    .filter((response) => Date.now() - new Date(response.createdAt).getTime() < 20000)
    .map((response) => ({
      noteId: response.noteId,
      timestamp: new Date(response.createdAt).getTime(),
    }));
};
